document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form#create_customer');
    if (!form) { console.warn('[MLD] Form #create_customer non trovato'); return; }

    const customerTagsField   = document.getElementById('customer_tags');
    const professionSelect    = document.getElementById('customer_tag');
    const sellerSelect        = document.getElementById('seller_tag');
    const b2bHiddenField      = document.getElementById('b2b_tag');
    const fidelityCheckbox    = document.getElementById('fidelity_card');
    const whatsappCheckbox    = document.getElementById('whatsapp_group');
    const referralHiddenField = document.getElementById('referral_tag');
    const referralNoteField   = document.getElementById('customer_referral');

    if (!customerTagsField) {
        console.error('[MLD] customer_tags hidden mancante: i tag non saranno inviati');
    }

    const VALID_REFS = ['V01','V02','V03','V04','V05','V06','V07','V08','V09','V10'];
    const STORAGE_KEY = 'mld_ref';

    function getValidatedRef() {
        try {
            const raw = new URLSearchParams(window.location.search).get('ref');
            const fromUrl = raw ? raw.trim().toUpperCase() : null;
            if (fromUrl && VALID_REFS.indexOf(fromUrl) !== -1) {
                try { sessionStorage.setItem(STORAGE_KEY, fromUrl); } catch (e) {}
                return fromUrl;
            }
            let stored = null;
            try { stored = sessionStorage.getItem(STORAGE_KEY); } catch (e) {}
            return (stored && VALID_REFS.indexOf(stored) !== -1) ? stored : null;
        } catch (e) {
            console.warn('[MLD] getValidatedRef error', e);
            return null;
        }
    }

    const refCode = getValidatedRef();
    if (refCode) {
        if (referralHiddenField) referralHiddenField.value = refCode;
        if (referralNoteField)   referralNoteField.value   = refCode;
        console.log('[MLD] Referral attivo:', refCode);
    }

    form.addEventListener('submit', function (e) {
        try {
            const tags = [];
            if (professionSelect && professionSelect.value)   tags.push(professionSelect.value);
            if (sellerSelect && sellerSelect.value)           tags.push(sellerSelect.value);
            if (fidelityCheckbox && fidelityCheckbox.checked) tags.push(fidelityCheckbox.value);
            if (whatsappCheckbox && whatsappCheckbox.checked) tags.push(whatsappCheckbox.value);
            if (b2bHiddenField && b2bHiddenField.value)       tags.push(b2bHiddenField.value);
            if (referralHiddenField && referralHiddenField.value) tags.push(referralHiddenField.value);

            if (customerTagsField) customerTagsField.value = tags.join(', ');
            console.log('[MLD] Tags inviati:', customerTagsField ? customerTagsField.value : '(no field)');
        } catch (err) {
            console.error('[MLD] Errore nella costruzione tag (submit prosegue):', err);
            // NB: non blocchiamo il submit, il form deve partire comunque
        }
    });
});